<template>
  <div class="custom-actions">
    <button class="btn btn-sm btn-success fa fa-pencil"
      @click="editar(rowData, rowIndex)"
      title="Editar"></button>
  </div>
</template>

<script>
  export default {
    name: 'actions-gitlab',
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      editar (data, index) {
        this.$router.push({ path: `/gestor/usuarios/${data.id}` })
      }
    }
  }
  </script>
